// Actions
import { NEW_RATE_CURRENCIES } from '../actions/currencyActions';

const initialState = {
  currencyRates: []

} // END initialState

export default function (state = initialState, action) {
  const { type, payload } = action;
  let newState;

  switch (type) {
    case NEW_RATE_CURRENCIES:
      newState = { currencyRates: payload };
      return { ...state, ...newState};

    default:
    return state;

  } // END switch
  
} // END reducer



// WEBPACK FOOTER //
// ./src/redux/reducers/currencyReducer.js